import { render, staticRenderFns } from "./ItemUpdates.vue?vue&type=template&id=04c4a178&"
import script from "./ItemUpdates.vue?vue&type=script&lang=js&"
export * from "./ItemUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports